// @LTG-ID: F-018
// @STATUS: BUILT
// @HERMETIC: false  // consumes ExternalCTA, sara-450.jpg public asset
// @DOCS: 08_FEATURES.md#F-018, source Landing Page.html lines 2929-2974
// @CHANGED: 2026-02 session_003 (CHG-0047)
// @OWNER: web
//
// F-018 — Sara Gonzalez principal profile. Portrait + bio + 5 credentials +
// dual CTA. Order CTA routes via ExternalCTA cta-id `team-snapshot-order`.
// Journal CTA is an internal `#journals` anchor (stays as bare <a>).

import ExternalCTA from "../../lib/external-cta";
import BubblePeriod from "../brand/BubblePeriod";
import ItalicPeriod from "../brand/ItalicPeriod";
import "./team.css";

const SARA_PORTRAIT_URL = "/assets/sara-450.jpg";

export function Team() {
    return (
        <section
            className="ltg-team-section"
            id="team"
            data-testid="team-section"
        >
            <div className="ltg-container">
                <div className="ltg-block-head">
                    <span
                        className="ltg-eyebrow"
                        data-testid="team-eyebrow"
                    >
                        The principal
                    </span>
                    <h2 data-testid="team-h2">
                        One signature on every engagement
                        <ItalicPeriod />
                    </h2>
                </div>

                <div className="ltg-principal" data-testid="team-card">
                    <div className="ltg-principal__portrait">
                        <img
                            src={SARA_PORTRAIT_URL}
                            alt="Sara Gonzalez, CPA. Managing Partner of KGOB CPAs and Advisors."
                            loading="lazy"
                            data-testid="team-portrait"
                        />
                        <div className="ltg-principal__portrait-tag">
                            <span>SARA GONZALEZ, CPA</span>
                            <span className="ltg-principal__portrait-city">
                                CHARLOTTE · NC
                            </span>
                        </div>
                    </div>

                    <div className="ltg-principal__body">
                        <div
                            className="ltg-principal__name"
                            data-testid="team-name"
                        >
                            Sara Gonzalez
                            <BubblePeriod />
                        </div>
                        <div className="ltg-principal__role">
                            CPA · Managing Partner · NC CPA #30420
                        </div>
                        <p className="ltg-principal__bio">
                            Sara leads KGOB CPAs &amp; Advisors, a
                            full-service practice founded in 1988 and
                            headquartered in Charlotte, North Carolina. The
                            firm has spent 38 years valuing every kind of
                            owner-operated business a Main-Street CPA firm
                            actually serves: trades, restaurants, healthcare
                            practices, manufacturers, professional services,
                            and technology.
                        </p>
                        <p className="ltg-principal__bio">
                            Let's Talk Growth is the digital expression of
                            that work, organized around three questions: what
                            is the business worth today, how do you make it
                            worth more, and how do you keep the gains when
                            you sell. Every Strategic Snapshot is produced
                            under the KGOB methodology Sara built.
                        </p>
                        <div
                            className="ltg-principal__creds"
                            data-testid="team-credentials"
                        >
                            <div className="ltg-cred">
                                <span className="ltg-cred__k">Title</span>
                                <span className="ltg-cred__v">
                                    CPA · Managing Partner, KGOB
                                </span>
                            </div>
                            <div className="ltg-cred">
                                <span className="ltg-cred__k">License</span>
                                <span className="ltg-cred__v">
                                    NC CPA #30420
                                </span>
                            </div>
                            <div className="ltg-cred">
                                <span className="ltg-cred__k">
                                    Firm established
                                </span>
                                <span className="ltg-cred__v">
                                    1988 · 38 years of practice depth
                                </span>
                            </div>
                            <div className="ltg-cred">
                                <span className="ltg-cred__k">
                                    Practice scope
                                </span>
                                <span className="ltg-cred__v">
                                    Tax, IRS resolution, advisory, valuations,
                                    entities
                                </span>
                            </div>
                            <div className="ltg-cred">
                                <span className="ltg-cred__k">Reach</span>
                                <span className="ltg-cred__v">
                                    North Carolina offices · clients in all
                                    50 states
                                </span>
                            </div>
                        </div>
                        <div className="ltg-principal__cta">
                            <ExternalCTA
                                ctaId="team-snapshot-order"
                                className="ltg-btn ltg-btn-primary"
                                data-testid="team-order-cta"
                            >
                                Get Your Valuation{" "}
                                <span
                                    className="ltg-arrow"
                                    aria-hidden="true"
                                >
                                    →
                                </span>
                            </ExternalCTA>
                            <a
                                href="#journals"
                                className="ltg-btn ltg-btn-ghost"
                                data-testid="team-journals-link"
                            >
                                Read Sara's journals →
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Team;
